import { Pipe } from 'angular2/core';

@Pipe({
  name: 'search'
})
export class SearchPipe {
  transform(value, [term]) {
    if (!value || !term) {
      return value;
    }
    return value.filter((item) => matchAgainst(term, item));
  }
}

function matchAgainst(term, data): boolean {
  for (let attr in data) {
    let val = data[attr];
    switch (typeof val) {
      case 'string':
        if (val.match(new RegExp(term, 'i'))) {
          return true;
        }
        break;
      case 'object':
        if (matchAgainst(term, val)) {
          return true;
        }
        break;
    }
  }
  return false;
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/search/search-pipe.ts
 **/